import { c as _c } from "react/compiler-runtime";
import { Modal } from '@7f-ui/components/modal/modal';
import { TextField } from '@7f-ui/components/text-field/text-field';
import { useToast } from '@7f-ui/components/toast/toast-provider';
import { trackCreateWishlist } from '@feat/feat-tracking/wishlist';
import { valibotResolver } from '@hookform/resolvers/valibot';
import { useForm } from 'react-hook-form';
import * as v from 'valibot';
import { toastDuration as duration } from '../constants';
import { useWishlistMutation } from '../hooks/use-wishlist-mutation';
import { NameLengthInfo } from './name-length-info';
type CreateWishlistModalProps = {
  isOpen: boolean;
  wishlistItemId?: string;
  onCloseCreateModal: () => void;
  onOpenChangeModal: () => void;
  onChangeLastUsedWishlist: (id: string | null) => void;
};
export function CreateWishlistModal(t0) {
  const $ = _c(35);
  const {
    isOpen,
    onCloseCreateModal,
    onOpenChangeModal,
    wishlistItemId,
    onChangeLastUsedWishlist
  } = t0;
  const toast = useToast();
  const {
    createWishlist,
    switchWishlists
  } = useWishlistMutation();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const validationSchema = v.object({
      name: v.pipe(v.string("Pflichtfeld"), v.minLength(1, "Pflichtfeld"), v.maxLength(40, "Bitte gib h\xF6chstens 40 Zeichen ein"))
    });
    t1 = useForm;
    t2 = {
      defaultValues: {
        name: ""
      },
      resolver: valibotResolver(validationSchema)
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const {
    register,
    handleSubmit,
    formState,
    setError,
    reset,
    control
  } = t1(t2);
  let t3;
  if ($[2] !== createWishlist || $[3] !== onChangeLastUsedWishlist || $[4] !== onCloseCreateModal || $[5] !== onOpenChangeModal || $[6] !== reset || $[7] !== setError || $[8] !== switchWishlists || $[9] !== toast || $[10] !== wishlistItemId) {
    t3 = async values => {
      if (values.name === "Meine Wunschliste") {
        setError("name", {
          message: "Der Name existiert bereits."
        });
        return;
      }
      const {
        createWishlist: createResult
      } = await createWishlist({
        input: {
          name: values.name
        }
      });
      if (createResult.error === "DUPLICATE_NAME") {
        setError("name", {
          message: "Der Name existiert bereits."
        });
        return;
      }
      const createdWishlistId = createResult.wishlist?.id;
      if (!wishlistItemId || !createdWishlistId) {
        return;
      }
      const {
        switchWishlists: switchResult
      } = await switchWishlists({
        wishlistItemId,
        newWishlistId: createdWishlistId
      });
      trackCreateWishlist();
      onChangeLastUsedWishlist(switchResult.id);
      onCloseCreateModal();
      reset();
      toast({
        type: "success",
        message: <>{"Gespeichert in "}<strong>{values.name}</strong></>,
        actionLabel: "\xC4NDERN",
        actionOnClick: onOpenChangeModal
      }, {
        toastOptions: {
          duration
        }
      });
    };
    $[2] = createWishlist;
    $[3] = onChangeLastUsedWishlist;
    $[4] = onCloseCreateModal;
    $[5] = onOpenChangeModal;
    $[6] = reset;
    $[7] = setError;
    $[8] = switchWishlists;
    $[9] = toast;
    $[10] = wishlistItemId;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== handleSubmit || $[13] !== t3) {
    t4 = handleSubmit(t3);
    $[12] = handleSubmit;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const onSubmit = t4;
  let t5;
  if ($[15] !== onCloseCreateModal) {
    t5 = <Modal.Header onClose={onCloseCreateModal}>Neue Liste</Modal.Header>;
    $[15] = onCloseCreateModal;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== onSubmit) {
    t6 = t7 => {
      const {
        children,
        ...props
      } = t7;
      return <form {...props} onSubmit={onSubmit} id="create-wishlist-form">{children}</form>;
    };
    $[17] = onSubmit;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== register) {
    t7 = register("name");
    $[19] = register;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const t8 = formState.errors.name?.message;
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <TextField {...t7} label="Name der Wunschliste" error={t8} maxLength={40} />;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== control) {
    t10 = <NameLengthInfo control={control} />;
    $[24] = control;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t6 || $[28] !== t9) {
    t11 = <Modal.Content Root={t6} renderFooter={_temp}>{t9}{t10}</Modal.Content>;
    $[26] = t10;
    $[27] = t6;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== isOpen || $[31] !== onCloseCreateModal || $[32] !== t11 || $[33] !== t5) {
    t12 = <Modal isOpen={isOpen} onClose={onCloseCreateModal} size="small">{t5}{t11}</Modal>;
    $[30] = isOpen;
    $[31] = onCloseCreateModal;
    $[32] = t11;
    $[33] = t5;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
}
function _temp() {
  return <Modal.Footer><Modal.Footer.Actions><Modal.Footer.Button type="submit">Liste erstellen</Modal.Footer.Button></Modal.Footer.Actions></Modal.Footer>;
}